import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import { UserListWebinar } from "components/AddUsersWebinar/UserListWebinar.jsx";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import ToolbarNewWebinar from "components/AddUsersWebinar/index";
import constants from "constants";

// const {
//   ADMIN_POST_ASSIGNED_USERS_SAGA
// } = constants;

const {
  showDeleteUsersConfirmationModal,
  adminUserFilter,
  setTempWebinar,
  adminPostAssignedUsersSaga,
} = actions;

const roles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
];

class AddUsersWebinar extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.timer = true;

    this.state = {
      user_ids: (props.webinar && props.webinar.assigned_ids) || [],
      per_page: 50,
      page: props.page || 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
        ...props.query,
      },
      startDate: null,
      endDate: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.total_pages != this.props.total_pages)
      this.setState({
        page: 1,
      });
  }
  // componentDidMount = () => {
  //   window.scrollTo(0, 0);
  // }

  componentWillMount = () => {
    this.updateUsersList();
  };

  deleteUsers = () => {
    if (this.state.user_ids.length > 0)
      this.props.deleteUsers(this.state.user_ids);
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.updateUsersList
    );
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const searchQuery = {
      ...this.state.searchQuery,
      order: {
        [field]: order,
      },
    };
    this.setState(
      {
        searchQuery,
      },
      this.updateUsersList
    );
  };

  checkedUserIds = (user_id) => {
    var ids = _.assign(this.state.user_ids),
      index = this.state.user_ids.indexOf(user_id);

    if (index == -1) {
      ids.push(user_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ user_ids: ids });
  };

  changeFilterQuery = (field, value) => {
    const query = { ...this.state.searchQuery, ...{ [field]: value } };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.searchQuery,
      ...{
        [`${field}_from`]: start,
        [`${field}_to`]: end,
      },
    };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  updateUsersList = () => {
    const { user_ids, page, searchQuery, per_page } = this.state;

    this.props.adminPostAssignedUsersSaga(
      user_ids,
      page,
      searchQuery,
      per_page
    );
    // this.props.userFilter(searchQuery, page);
  };

  onAddCheckedUsersClick = () => {
    this.props.setTempWebinar({
      ...this.props.webinar,
      ...{
        assigned_ids: this.state.user_ids,
      },
    });
    // this.props.adminPostAssignedUsersSaga(this.state.user_ids)
    const groupId = this.props.webinar.group_id;

    if (groupId) {
      return this.props.router.push({
        pathname: `/groups/${groupId}/webinars/new`,
        state: { from: "addUsersWebinar" },
      });
    }

    return this.props.router.push({
      pathname: `/webinars/new`,
      state: { from: "addUsersWebinar" },
    });
  };

  render() {
    const { changeFilterQuery, setState, deleteUsers, onDateRangeChange } =
      this;
    return (
      <main className="site--width container_statistics">
        <ToolbarNewWebinar
          filterProps={{
            ...this.state,
            changeFilterQuery,
            setState,
            roles,
            onDateRangeChange,
          }}
          toolsProps={{
            ...this.state,
            onAddCheckedUsersClick: this.onAddCheckedUsersClick,
            deleteUsers,
            count: this.props.count,
          }}
        />
        <div className="admin_user_table admin_table">
          <UserListWebinar
            onOrderChange={this.onOrderChange}
            query={this.state.searchQuery}
            users={this.props.assignedUsers || this.props.users}
            checkedUserIds={this.checkedUserIds}
            user_ids={this.state.user_ids}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function sortByIncludedInArray(sortArray, arrayIncludedIn) {
  return sortArray.sort(
    (a, b) =>
      isIncludedIn(arrayIncludedIn, b.id) - isIncludedIn(arrayIncludedIn, a.id)
  );
}

function isIncludedIn(array, item) {
  return array.map(Number).indexOf(item) > -1;
}

function mapStateToProps(state) {
  return {
    webinar: state.webinars.tmp,
    users: state.users.adminUsers.values, //sortByIncludedInArray(state.users.adminUsers.values, state.webinars.tmp.assigned_ids),
    assignedUsers: state.users.assignedUsers.values,
    count: state.users.assignedUsers.count,
    total_pages: state.users.assignedUsers.total_pages,
    page: state.users.assignedUsers.page,
    query: state.users.assignedUsers.query,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    setTempWebinar: (webinar) => dispatch(setTempWebinar(webinar)),
    deleteUsers: (user_ids) =>
      dispatch(showDeleteUsersConfirmationModal(user_ids)),
    userFilter: (query, page) => dispatch(adminUserFilter(query, page)),
    adminPostAssignedUsersSaga: (assigned_users, page, query, per_page) =>
      dispatch(
        adminPostAssignedUsersSaga(assigned_users, false, page, query, per_page)
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddUsersWebinar);



// WEBPACK FOOTER //
// ./src/containers/AddUsersWebinar/AddUsersWebinar.js